import Menu from '@hud/web-components/Menu/Menu';
import { Container } from './SlackIntegrations.styles';
import IconButton from '@hud/web-components/DesignSystem/Components/IconButton/IconButton';
import SlackLogo from './slack-logo.svg?react';
import { SlackIntegrationErrorCode } from '@hud/slack-dtos/api';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import classNames from 'classnames';

type SlackIntegrationsProps = {
  onDisconnectClick: () => void;
  onReauthenticateClick: () => void;
  integrationError?: SlackIntegrationErrorCode;
};

const SlackIntegrations: React.FC<SlackIntegrationsProps> = ({
  onDisconnectClick,
  onReauthenticateClick,
  integrationError,
}) => {
  return (
    <Container>
      <header>
        <h3>Configured Slack Channels</h3>
        <div className={classNames('status', { error: !!integrationError })}>
          <SlackLogo />
          {integrationError ? (
            <div>
              <span>Connection issue to Hud</span>
              <HudIcon icon="designSystem.infoCircle" />
            </div>
          ) : (
            <span>Connected to Hud</span>
          )}
          <Menu.Menu zIndex={2000}>
            <Menu.Target>
              <IconButton
                onClick={() => {}}
                icon="designSystem.threeDots"
                selectable={false}
              />
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={onReauthenticateClick}>Re-authenticate</Menu.Item>
              <Menu.Item onClick={onDisconnectClick}>Disconnect</Menu.Item>
            </Menu.Dropdown>
          </Menu.Menu>
        </div>
      </header>
    </Container>
  );
};

export default SlackIntegrations;
